var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50464 14.162L14.162 8.5047",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97601 3.97607L6.61935 6.61941",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9213 4.69533C12.0729 3.99227 11.9928 3.25903 11.6929 2.60532C11.393 1.95162 10.8895 1.4126 10.2577 1.06893C9.62588 0.725266 8.89978 0.595429 8.18804 0.698852C7.4763 0.802274 6.81719 1.13339 6.30933 1.64266L1.64267 6.30933C1.13328 6.81736 0.802149 7.47672 0.698863 8.18869C0.595576 8.90066 0.725688 9.62693 1.06972 10.2588C1.41375 10.8906 1.95318 11.394 2.60726 11.6936C3.26134 11.9932 3.99486 12.0729 4.698 11.9207",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 15.3334C13.5425 15.3334 15.3333 13.5425 15.3333 11.3334C15.3333 9.12424 13.5425 7.33337 11.3333 7.33337C9.12417 7.33337 7.33331 9.12424 7.33331 11.3334C7.33331 13.5425 9.12417 15.3334 11.3333 15.3334Z",
    stroke: "#034D83",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationHistory);
export default __webpack_public_path__ + "static/media/medication-history.f8b7fc2cea2338ead4a25da553ac84eb.svg";
export { ForwardRef as ReactComponent };